import { FC } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import ThinkingDots from './ThinkingDots';
import NaviOrb from './NaviOrb';

type AssistantMessageProps = {
  content?: string;
  thinking?: boolean;
  streaming?: boolean;
};

const AssistantMessage: FC<AssistantMessageProps> = ({
  content,
  thinking = false,
  streaming = false,
}) => (
  <div className="navi-assistant-message">
    <div className="navi-assistant-message__orb">
      <NaviOrb size={28} showSparkles={false} />
    </div>
    <div className="navi-assistant-message__bubble">
      {thinking ? (
        <ThinkingDots />
      ) : (
        <div
          className={`navi-assistant-message__markdown${streaming ? ' navi-assistant-message__markdown--streaming' : ''}`}
        >
          <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {content ?? ''}
          </ReactMarkdown>
        </div>
      )}
    </div>
  </div>
);

export default AssistantMessage;
